import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	neutralColor: {
		id: 'fabric.status.color.grey',
		defaultMessage: 'Grey',
		description: 'Tooltip for the grey color in color palette',
	},
	purpleColor: {
		id: 'fabric.status.color.purple',
		defaultMessage: 'Purple',
		description: 'Tooltip for the purple color in color palette',
	},
	blueColor: {
		id: 'fabric.status.color.blue',
		defaultMessage: 'Blue',
		description: 'Tooltip for the blue color in color palette',
	},
	redColor: {
		id: 'fabric.status.color.red',
		defaultMessage: 'Red',
		description: 'Tooltip for the red color in color palette',
	},
	yellowColor: {
		id: 'fabric.status.color.yellow',
		defaultMessage: 'Yellow',
		description: 'Tooltip for the yellow color in color palette',
	},
	greenColor: {
		id: 'fabric.status.color.green',
		defaultMessage: 'Green',
		description: 'Tooltip for the green color in color palette',
	},
	statusInputLabel: {
		id: 'fabric.status.input.label',
		defaultMessage: 'Set a status',
		description: 'Aria label text for the status input field',
	},
});
